import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CheckoutService } from 'src/app/services/checkout/checkout.service';
import { LogService } from 'src/app/services/common/log.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-update-details-modal',
  templateUrl: './update-details-modal.component.html',
  styleUrls: ['./update-details-modal.component.scss']
})

export class UpdateDetailsModalComponent {
  public pricingPlans = environment.stripePlans;

  constructor(
    public activeModal: NgbActiveModal,
    private _checkoutService: CheckoutService,
    private _logService: LogService
  ) {}

  public buyIdentibasePlusSubscription() {
    const planId = this.pricingPlans.identibasePlusCod;
  
    this._checkoutService.checkout([planId]).subscribe({
      next: () => {},
      error: (err) => {
        this._logService.error('An error occurred: ', err);
      },
    });
  }
}
